import { registerBlockType } from '@wordpress/blocks';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody } from '@wordpress/components';
import { checkConditionalLogic } from '../../utils/ConditionalLogicChecker'; // Ensure this path is correct
import { fieldComponents, defaultValues } from '../../components/fieldComponents'; // Ensure this path is correct

(() => {
    // Basic check to ensure voxycureWPBlocks exists and is not empty
    if (
        typeof voxycureWPBlocks !== 'object' ||
        voxycureWPBlocks === null ||
        Object.keys(voxycureWPBlocks).length === 0
    ) {
        console.warn('voxycureWPBlocks global object not found or is empty. No blocks will be registered.');
        return;
    }

    // Loop through each block configuration provided in voxycureWPBlocks
    Object.entries(voxycureWPBlocks).forEach(([blockName, config]) => {

        let icon;

        if (config.icon) {
            // If it looks like an SVG (starts with <svg), treat it as SVG
            if (config.icon.trim().startsWith('<svg')) {
                icon = {
                    src: () =>
                        wp.element.createElement('span', {
                            dangerouslySetInnerHTML: { __html: config.icon }
                        }),
                };
            } else {
                // Otherwise treat it as a Dashicon string
                icon = config.icon;
            }
        } else {
            icon = 'block-default'; // fallback
        }

        registerBlockType(`voxyframe/${blockName}`, {
            title: config.title,
            icon: icon,
            category: config.category || 'design',
            keywords: config.keywords || [],
            description: config.description || '',
            apiVersion: 3,

            // The edit function defines the structure of the block in the editor
            edit({ attributes, setAttributes }) {

                const fields = config.fields || [];

                // Separate fields based on location
                const defaultFields = fields.filter((f) => f.location === 'default');
                const inspectorFields = fields.filter((f) => f.location === 'inspector');

                // Helper to render a list of fields dynamically
                const renderFields = (fieldList) => {
                    return fieldList
                        .filter((field) => {
                            return checkConditionalLogic(attributes, field.conditional_logic);
                        })
                        .map((field) => {
                            // Determine the correct field component, defaulting to 'text' if not found
                            const FieldComponent = fieldComponents[field.type] || fieldComponents['text'];

                            // Get the current value from attributes, or use a default if not set
                            let value = attributes[field.field_key];
                            if (
                                (typeof value === 'undefined' || value === '') &&
                                defaultValues.hasOwnProperty(field.type)
                            ) {
                                value = defaultValues[field.type];
                            }

                            // Define the onChange handler for the field
                            const onChange = (val) => {
                                const parsedValue = field.type === 'number' ? Number(val) : val;
                                setAttributes({ [field.field_key]: parsedValue });
                            };

                            return (
                                <FieldComponent
                                    // A unique and stable key is crucial for React's reconciliation
                                    key={field.field_key || field.label || field.name}
                                    field={field} // Pass the field configuration
                                    value={value} // Pass the current value
                                    onChange={onChange} // Pass the update handler
                                />
                            );
                        });
                };

                return (
                    <>
                        {/* Inspector Controls for sidebar fields */}
                        {inspectorFields.length > 0 && (
                            <InspectorControls>
                                <PanelBody title="Settings" initialOpen={true}>
                                    {renderFields(inspectorFields)}
                                </PanelBody>
                            </InspectorControls>
                        )}

                        {/* The main block editor interface for dynamic fields */}
                        <div className="wp-block voxy-block">

                            <div className="voxy-block__header">
                                {config.title}
                            </div>

                            <div className="voxy-block__body">
                                {renderFields(defaultFields)}
                            </div>
                        </div>
                    </>
                );
            },

            // The save function determines what is saved to the database.
            // In this case, it returns null because the block's rendering
            // will be handled entirely on the PHP side using block.json and render_callback.
            save() {
                return null; // Always rendered via PHP
            },
        });
    });
})();